import React from "react";
import styled from "styled-components";
import Arrow from "assets/images/icon/ic-arrow-next.svg";

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 16px 0;
  padding: 16px 18px;
  background: #f7f7f9;
  border-radius: 8px;
  &::after {
    content: "";
    display: inline-block;
    width: 8px;
    height: 14px;
    background: url(${Arrow});
    margin-left: auto;
  }
`;

const Icon = styled.div`
  display: inline-block;
  width: 32px;
  height: 32px;
  background-image: url(../../..${({ src }) => src});
  background-size: cover;
  background-position: center;
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 6px;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #484760;
  b {
    display: inline-block;
    font-weight: 600;
    font-size: 15px;
    line-height: 18px;
  }
`;

const Banner = ({ icon, text = [], onClick }) => {
  return (
    <Wrapper className="banner" onClick={onClick}>
      {icon && <Icon src={icon} />}
      <Text>
        <p>{text[0]}</p>
        <b>{text[1]}</b>
      </Text>
    </Wrapper>
  );
};

export default Banner;
